<template>
  <div class="wrapper">
    <header class="header" id="header">
      <div class="container">
        <div class="header-wrap">
          <div class="header-logos">
            <img class="tg-upload-page__brand-logo" src="@/assets/img/ui/logo.svg" alt="Мистраль" width="148" height="40" />
          </div>
        </div>
      </div>
    </header>

    <main class="main tg-upload-page">
      <div class="container container--small">
        <div class="tg-upload-page__status">
          {{ statusMessage }}
        </div>
      </div>
    </main>

    <button ref="hiddenUploadTrigger" type="button" class="tg-upload-page__hidden-trigger" @click="openWidget">
      open
    </button>
  </div>
</template>

<script>
/* global qrWidget */
import {
  getToken,
  getUserInfo,
  setAuthHeader,
  APMCHECK_API_KEY,
  APMCHECK_API_URL,
  getMainSettings,
} from '@/api';
import { state } from '@/store';
import adRiver from '@/services/adriver';

export default {
  name: 'TelegramUploadReceiptPage',
  data() {
    return {
      userUuid: '',
      widgetReady: false,
      openAttemptTimer: null,
      openAttemptCount: 0,
      statusMessage: 'Открываем виджет загрузки чека...',
    };
  },
  async mounted() {
    document.body.classList.add('tg-upload-receipt-page');

    const token = getToken();
    if (!token) {
      this.$router.push('/');
      return;
    }

    try {
      setAuthHeader();
      const settings = await getMainSettings();
      const promoStatus = settings?.status;
      if (promoStatus === 'future') {
        this.statusMessage = 'Акция ещё не началась. Следите за датами на сайте rice.ru и подключайте Telegram-бота по ссылке из правил акции.';
        return;
      }
      if (promoStatus === 'past') {
        this.statusMessage = 'Акция завершена. Спасибо, что были с нами! Призы вручаются до 22 мая 2026 г.';
        return;
      }
      const userInfo = await getUserInfo();
      this.userUuid = userInfo?.uuid || '';
      this.initQrWidget();
      this.scheduleWidgetOpen();
    } catch (error) {
      this.$router.push('/');
    }
  },
  beforeUnmount() {
    document.body.classList.remove('tg-upload-receipt-page');

    if (this.openAttemptTimer) {
      clearTimeout(this.openAttemptTimer);
      this.openAttemptTimer = null;
    }
  },
  methods: {
    initQrWidget() {
      if (document.getElementById('apm-scan-qr')) {
        this.widgetReady = true;
        return;
      }

      qrWidget.init('apm-widget', {
        api: APMCHECK_API_URL,
        apiKey: APMCHECK_API_KEY,
        userUuid: this.userUuid,
        callbacks: {
          onReceiptSentSuccess: () => {
            adRiver.trackReceiptUploadSuccess();
            state.checkSoon = true;
            state.isUploadOpened = false;
          },
          onReceiptSentError: () => {
            state.isUploadOpened = false;
          }
        }
      });
      this.widgetReady = true;
    },
    scheduleWidgetOpen() {
      const maxAttempts = 20;
      const delayMs = 200;

      const tryOpen = () => {
        this.openAttemptCount += 1;
        const qrElement = document.getElementById('apm-scan-qr');

        if (qrElement) {
          if (this.$refs.hiddenUploadTrigger) {
            this.$refs.hiddenUploadTrigger.click();
          } else {
            this.openWidget();
          }
          return;
        }

        if (this.openAttemptCount < maxAttempts) {
          this.openAttemptTimer = setTimeout(tryOpen, delayMs);
        }
      };

      tryOpen();
    },
    openWidget() {
      if (!this.widgetReady) {
        return;
      }
      const qrElement = document.getElementById('apm-scan-qr');
      if (qrElement) {
        state.isUploadOpened = true;
        qrElement.click();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tg-upload-page {
  min-height: 40vh;
}

.tg-upload-page__hidden-trigger {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  clip: rect(0, 0, 0, 0);
  overflow: hidden;
  white-space: nowrap;
}

.tg-upload-page__brand-logo {
  display: block;
  width: 100%;
  max-width: 14.8rem;
  height: auto;
}
</style>
